/* @flow strict */

import * as React from 'react';
import SCHBody from './body';
import { GET, POST, PUT } from '/client/src/api';
import SchEmailsPageModal from './modal';
import NProgressCustom from '/client/src/components/nProgress';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { convertToUTC } from '/client/src/utils/jstz';

import './styles.scss';

type PropsType = {
  eventId: string | number
};

const SchEmailsPage = ({ eventId }: PropsType): React.Element<'div'> => {
  const [pending, setPending] = React.useState(true);
  const [isFetching, setIsFetching] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [singleRow, setSingleRow] = React.useState({});
  const [isOpen, _handleToggleModal] = React.useState(false);
  const EventDetailContext = React.useContext(EventDetailContainerContext);
  const fetchData =  async () => {
    try {
      const { result } = await GET(`/api/v1/1/events/${eventId}/reminders`);

      setRows(result);
      setPending(false);
    } catch (e) {
      console.log(e);
      console.error('Cant get reminders');
      setPending(false);
      setIsFetching(false);
    }
  };

  const toggleSchStatus = async (schId: number | string, status: string): boolean => {
    setIsFetching(true);

    try {
      const { success } = await PUT(`/api/v1/1/events/${eventId}/reminders/${schId}/status`, {
        id: schId,
        status
      });

      if (success) await fetchData();

      setIsFetching(false);
    } catch (e) {
      setIsFetching(false);
      console.log(e);
      console.error('Cant change status');
    }
  };

  const handleToggleModal = (status: boolean, data?: {}) => {
    _handleToggleModal(status);

    if (!status) {
      setSingleRow({});
    } else if (_.size(data)) {
      setSingleRow(data);
    }
  };

  const saveSchedule = async (data: {}, isUpdate?: boolean) => {
    try {
      setPending(true);
      NProgressCustom(true);

      const _data = {
        'event_id': eventId,
        'event_schedule_id': _.get(rows[0], 'event_schedule_id', null),
        'recipients': data.recepients,
        'name': data.emailName,
        'subject': data.emailSubject,
        'reply_to': data.replyToEmail,
        'recipient_type': data.to,
        'body': data.MCEbody,
        'send_type': data.isShowPicker ? 'custom' : 'now', // custom or now
        'schedule_time_utc': data.sendEmailModalSchedule && convertToUTC(data.sendEmailModalSchedule, EventDetailContext.eventDetail.time_zone_id) // date
      };

      if (isUpdate) {
        await PUT(`/api/v1/1/events/${eventId}/reminders/${data.id}`, _data);
      } else {
        await POST(`/api/v1/1/events/${eventId}/reminders`, _data);
      }

      NProgressCustom(false);

      fetchData();
    } catch (e) {
      NProgressCustom(false);
      setPending(false);

      console.log(e);
      console.error('Cant add schedule');
    }
  };

  React.useEffect(() => {
    fetchData();
  }, [eventId]);

  return (
    <section>
      <div className="panel panel-default panel-page no-border SCHEmailPage">
        <div
          className="navmar navbar-inverse customers-navbar navbar-page-toolbar send-mail-navbar"
          style={{ marginBottom: 0 }}
        >
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar-collapse-customer-database"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>

          <div className="collapse navbar-collapse" id="navbar-collapse-customer-database">
            <ul className="nav">
              <li>
                <div className="navbar-header">
                  <div className="navbar-brand">
                    <span style={{ color: '#fff' }}>Schedule Emails</span>
                  </div>
                </div>
              </li>
            </ul>

            <ul className="navbar-right schModalBtn" style={{ marginRight: 0, marginBottom: 0 }}>
              <li className='navbar-brand' onClick={(): any => handleToggleModal(true)} style={{ cursor: 'pointer' }}>
                <i className="icon icon-calendar" />
                <span>add new schedule</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="panel-body">
          <SCHBody
            progressPending={pending}
            data={rows}
            handleToggleModal={handleToggleModal}
            handleToggleSchStatus={toggleSchStatus}
            isFetching={isFetching}
          />
        </div>
      </div>

      {isOpen ?
        <SchEmailsPageModal
          isOpen={isOpen}
          handleShowSchEmailsPageModal={handleToggleModal}
          handleSave={saveSchedule}
          singleRow={singleRow}
          eventId={eventId}
        /> :
        null
      }
    </section>
  );
};

export default SchEmailsPage;
